import React from "react";
import styled from "styled-components";
import { fonts } from "../../../../../../theme/fonts";

export const Confirmation = ({ ...props }) => {
  return (
    <RegistrationConfirmation>
      <ConfirmationHeader>
        You’re now registered for the livestream concert and have been entered
        for a chance to win a virtual meet & greet!
      </ConfirmationHeader>
      <ConfirmationButton href={"#"} target="_blank" rel="noopener noreferrer">
        All Done!
      </ConfirmationButton>
    </RegistrationConfirmation>
  );
};

const RegistrationConfirmation = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  font-family: ${fonts.brandMedium};
`;

const ConfirmationHeader = styled.h3`
  color: #102b4e;
  font-size: 28px;
`;

const ConfirmationButton = styled.a`
  background-color: #4580dd;
  color: #ffffff;
  font-family: ${fonts.brandLight};
  transition: all ease 0.3s;
  outline: none;
  border: none;
  padding: 25px;
  text-align: center;
  text-decoration: none;

  &:hover,
  &:focus {
    background-color: #305da2;
  }

  @media only screen and ${(props) => props.theme.maxMedia.small} {
    font-size: 30px;
  }
`;
